/** @format */

import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { Icon, Popup } from 'semantic-ui-react';

import { Endpoints as url } from '../../lib/endpoints';
import devLog from '../../lib/devLog';

// @TODO: to move to a global
const BRANCH = process.env.ENV_COMMIT_REF_NAME || null;
const TAG = process.env.ENV_COMMIT_TAG || null;

function Informations() {
  const [isUpdated, setIsUpdated] = useState(false);
  const [mgmtsrvV2, setMgmtsrvV2] = useState({
    name: null,
    commitSha: null,
    commitShortSha: null,
    branch: null,
    tag: null,
  });
  const [frontend] = useState({
    branch: BRANCH,
    tag: TAG,
  });

  useEffect(() => {
    Axios.get(url.Informations(), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        setIsUpdated(true);
        setMgmtsrvV2({ ...res.data });
      })
      .catch(err => {
        devLog(err);
      });
  }, []);

  return (
    <>
      <Popup
        trigger={
          <span style={{ opacity: 0.4, textAlign: 'right' }}>
            <small>
              <Icon name="info circle" color="grey" />
            </small>
          </span>
        }
      >
        <>
          {isUpdated && frontend.tag && (
            <div>
              <small>gui: {frontend.tag} </small>
            </div>
          )}
          {isUpdated && mgmtsrvV2.tag && (
            <div>
              <small>v2: {mgmtsrvV2.tag}</small>
            </div>
          )}
        </>
      </Popup>
    </>
  );
}

export { Informations };
